import $ from "jquery";

$(() => {
    function setImageSources() {
        const icons = document.querySelectorAll(".blue-stopper");

        icons.forEach((icon) => {
            const index = parseInt(icon.getAttribute("data-index"), 10);
            const imageSrc =
                index % 3 === 1
                    ? "/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/static-icons/blue.svg"
                    : index % 3 !== 0
                        ? "/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/static-icons/red.svg"
                        : "/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/static-icons/yellow.svg";
            icon.src = imageSrc;
        });
    }

    function setTimelineSegmentTopValues() {
        const segments = document.querySelectorAll(".timeline-segment-parent");
        let oddTop = 0;
        let evenTop = -27;
        let oddTopMobile = 0;
        let evenTopMobile = -18;

        const isMobile = window.matchMedia("(max-width: 992px)").matches;
        const timelineParentBox = document.querySelector(".timeline-parent-box");
        const parentBoxHeight = timelineParentBox ? timelineParentBox.offsetHeight : 0;

        segments.forEach((segment, index) => {
            if (isMobile) {
                if (index % 2 === 0) {
                    segment.style.top = `${oddTopMobile}px`;
                    oddTopMobile -= 37;
                } else {
                    segment.style.top = `${evenTopMobile}px`;
                    evenTopMobile -= 37;
                }
            } else {
                if (index % 2 === 0) {
                    segment.style.top = `${oddTop}px`;
                    oddTop -= 55;
                } else {
                    segment.style.top = `${evenTop}px`;
                    evenTop -= 55;
                }
            }
        });

        if (parentBoxHeight) {
            timelineParentBox.style.height = `${parentBoxHeight + (isMobile ? evenTopMobile : evenTop) }px`;
        }
    }

    function addTimelineSegmentClasses() {
        const segments = document.querySelectorAll(".timeline-segment");

        segments.forEach((segment, index) => {
            if (index % 2 === 0) {
                segment.classList.add("timeline-odd-segment");
            } else {
                segment.classList.add("timeline-even-segment");
            }
        });
    }

    function addColorClassesToTimelineSegments() {
        const colors = ["blue", "red", "yellow"];

        const segments = document.querySelectorAll(".timeline-segment");

        segments.forEach((segment, index) => {
            const colorIndex = index % colors.length;
            segment.classList.add(colors[colorIndex]);
        });
    }

    function formatTimelineIndexes() {
        const icons = document.querySelectorAll(".timeline-icon");

        icons.forEach((icon) => {
            const rawIndex = icon.getAttribute("data-raw-index");
            const formattedIndex = String(rawIndex).padStart(2, '0');
            icon.textContent = formattedIndex;
        });
    }

    setImageSources();
    addColorClassesToTimelineSegments();
    addTimelineSegmentClasses();
    setTimelineSegmentTopValues();
    formatTimelineIndexes();

    // window.addEventListener('resize', setTimelineSegmentTopValues);
});
